var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDelete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.17,
    height: 13.404,
    viewBox: "0 0 11.17 13.404",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M13.5,13.5h.931v5.745H13.5Z",
    transform: "translate(-9.777 -8.713)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M20.25,13.5h.931v5.745H20.25Z",
    transform: "translate(-13.734 -8.713)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M4.5,6.75v.957h.931v9.574a.944.944,0,0,0,.931.957h7.447a.944.944,0,0,0,.931-.957V7.707h.931V6.75ZM6.362,17.282V7.707h7.447v9.574Z",
    transform: "translate(-4.5 -4.835)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M13.5,2.25h3.723v.957H13.5Z",
    transform: "translate(-9.777 -2.25)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete.a4e8b6742e9bc5122ebfbcfe1f066649.svg";